<script lang="ts">
	import { format } from 'svelte-i18n';

	import { Toggle, Alert, Select, Text } from '@Shelly/shelly-design-system';

	import { onSettingsResponse } from 'src/helpers/device_settings_helpers';
	import {
		getInitLoadedPeriodStatistics,
		isPrevPeriodComparisonEnabled,
		rangeOptions,
	} from 'src/components/Chart/chart_control_helpers';
	import { save_home } from 'src/helpers/home_helpers';
	import { isPremiumUser } from 'src/helpers/user_helpers';

	let waitForResponseSavePrevious = false,
		waitForResponseInitPeriod = false,
		checked = isPrevPeriodComparisonEnabled(),
		chartPeriods = rangeOptions.filter(
			(i) =>
				!/^(custom|billing_date|hour)$/.test(i.period) ||
				(i.period == 'hour' && isPremiumUser()),
		),
		initLoadedPeriod = getInitLoadedPeriodStatistics(chartPeriods);
	if (checked == null) checked = true;

	const savePreviousComparison = async () => {
		if (waitForResponseSavePrevious) return;
		waitForResponseSavePrevious = true;
		const prevPeriodComparison = !checked,
			res = await save_home('prev_period_comparison', {
				value: prevPeriodComparison,
			});
		if (res.isok) checked = prevPeriodComparison;
		onSettingsResponse(res);
		waitForResponseSavePrevious = false;
	};

	const saveChartInitLoadedPeriod = async (e: CustomEvent) => {
		if (waitForResponseInitPeriod) return;
		waitForResponseInitPeriod = true;
		const res = await save_home('init_loaded_period_statistics', e.detail.value);
		onSettingsResponse(res);
		waitForResponseInitPeriod = false;
	};
</script>

<Alert
	class="mb-s"
	type="info"
	heading={$format('alert_app_settings_statistics_apply_global_chart_heading', {
		default: 'All settings will be applied globally to all charts in the application message',
	})}
/>

<Toggle {checked} size="m" on:click={savePreviousComparison} id="toggle-stats-prev-period">
	{$format('toggle_app_settings_statistics_previous_period_comparison', {
		default: 'Show previous period comparison for energy statistics.',
	})}
</Toggle>

<Text styleType="body-small" class="mt-m mb-s">
	{$format('text_app_settings_statistics_select_default_period', {
		default: 'Select the default initially loaded period',
	})}
</Text>
<Select
	aria-label={$format('select_default_period', { default: 'Select default period' })}
	size="m"
	value={{
		title: $format(`option_${initLoadedPeriod.period}`),
		value: initLoadedPeriod.period,
	}}
	icon="fas fa-clock-rotate-left"
	class="width-md-l"
	options={chartPeriods.map((i) => ({
		title: $format(`option_${i.period}`),
		value: i.period,
	}))}
	on:change={saveChartInitLoadedPeriod}
	id="select-init-loaded-period"
/>
